import { StatesModule } from '@uirouter/angular';
import { FiDocumentTemplateRootState } from '@fi-app/document-template/states/document-template-module-states';
import { FiDocumentTemplateListState } from '@fi-app/document-template/states/document-template-list-state';
import { FiDocumentTemplateEditState } from '@fi-app/document-template/states/document-template-edit-state';
import { FiDocumentTemplateCreateState } from '@fi-app/document-template/states/document-template-create-state';
import { FiDocumentTemplateViewState } from '@fi-app/document-template/states/document-template-view-state';

export const FiDocumentTemplateStates: StatesModule = {
    states: [
        FiDocumentTemplateRootState,
        FiDocumentTemplateListState,
        FiDocumentTemplateEditState,
        FiDocumentTemplateCreateState,
        FiDocumentTemplateViewState,
    ],
};
